export const APP_BASE_URL = '/'
export const DIARY_URL = 'agenda'
export const DIARY = 'Agenda'
export const HISTORY_URL = 'histoire'
export const HISTORY = 'Histoire'
export const REFERENCE_TEAM_URL = 'equipe-referente'
export const REFERENCE_TEAM = 'Équipe référente'
export const EMPLOYMENT_SUPPORT_URL = 'accompagnement-emploi'
export const EMPLOYMENT_SUPPORT = 'Accompagnement à l’emploi'
export const PROJECTS_URL = 'projets'
export const PROJECTS = 'Nos projets'
export const PROJECT_URL = `projet/:slug`
export const PROJECT = 'Nom du projet'
export const GIFT_OBJECT_URL = 'don-objets'
export const GIFT_OBJECT = "Don d'objets"
export const SHOP_URL = 'boutiques'
export const SHOP = 'Boutiques solidaires'
export const RECOVERY_WORKSHOP_URL = 'ateliers-recup'
export const RECOVERY_WORKSHOP = 'Ateliers récup’'
export const ART_CRAFT_URL = 'artisanat'
export const ART_CRAFT = 'Artisanat'
export const BENEFIT_URL = 'prestations'
export const BENEFIT = 'Prestations'
export const DIY_URL = 'bricotheque'
export const DIY = 'Bricothèque'
export const CONTACT_URL = 'contactez-nous'
export const CONTACT = 'Contactez-nous'
export const ACTIVITY_REPORT_URL = 'rapports-activite'
export const ACTIVITY_REPORT = 'Rapports d’activité'
export const RECRUITMENT_URL = 'recrutement'
export const RECRUITMENT = 'Recrutement'
export const BECOME_VOLUNTEER_URL = 'devenir-benevole'
export const BECOME_VOLUNTEER = 'Devenir bénévole'
export const PARTNER_URL = 'partenaire'
export const PARTNER = 'Partenaires'

export const PAGES = {
	DAIRY: '/pages/13',
	HISTORY: '/pages/18',
	REFERENCE_TEAM: 'pages/20',
	EMPLOYMENT_SUPPORT: 'pages/24',
	PROJECTS: 'pages/26',
	GIFT_OBJECT: 'pages/28',
	SHOP: 'pages/30',
	RECOVERY_WORKSHOP: 'pages/32',
	ART_CRAFT: 'pages/34',
	BENEFIT: 'pages/36',
	DIY: 'pages/38',
	CONTACT: 'pages/40',
	ACTIVITY_REPORT: 'pages/42',
	RECRUITMENT: 'pages/44',
	BECOME_VOLUNTEER: 'pages/46',
	PARTNER: 'pages/48',
}

export const SERVICES = {
	PLACES: 'lieu',
	EVENTS: 'evenement?',
	FIGURES: 'chiffres',
	IMAGES: 'media/',
	MISSIONS: 'missions',
	COLLECTERIE: 'collecterie',
	HISTORY: 'histoire',
	POLE: 'pole',
	DIRECTOR: 'c_administration',
	PARCOURS: 'parcours',
	REMARK: 'commentaire',
	PROJECT: 'projet',
	PROJECT_DETAIL: 'projet',
	ANIMATION: 'animation',
	PARTENAIRE: 'partenaires',
	POSTE: 'postes',
	RAPPORT: 'rapports',
	BRICOTHEQUE: 'bricotheque',
	PRESTATION: 'prestations',
	ARTISANAT: 'artisanat',
	BOUTIQUE: 'boutiques_solidaires',
	ATELIER: 'atelier',
	INFO: 'infos',
}

export const EVENTS = {
	TYPES: {
		atelier: 'success.main',
		evenement: 'success.main',
		vente: 'warning.main',
		fete: 'secondary.main',
	},
}

export const CATEGORIES = {
	FIGURES: {
		ARTISANAT: { name: 'artisanat', id: '16' },
		ATELIER: { name: 'atelier', id: '15' },
		BOUTIQUE: { name: 'boutique', id: '14' },
		DON: { name: 'don', id: '13' },
		PROJET: { name: 'projet', id: '12' },
		ACCOMPAGNEMENT: { name: 'accompagnement', id: '11' },
		COLLECTERIE: { name: 'collecterie', id: '9' },
	},
	POLES: {
		ADMINISTRATIF: { name: 'administratif', id: '22', label: 'Pôle administratif' },
		PRODUCTION: { name: 'production', id: '19', label: 'Pôle production' },
		RESSOURCERIE: { name: 'ressourcerie', id: '18', label: 'Pôle ressourcerie' },
		RH_ACCOMPAGNEMENT_FORMATION: {
			name: 'rhAccompagnementFormation',
			id: '21',
			label: 'Pôle RH, Accompagnement et formation',
		},
		SENSIBILISATION: { name: 'sensibilisation', id: '20', label: 'Pôle sensibilisation' },
	},
	PARTENAIRE: {
		ALTERNATIVE: {
			name: 'alternatives',
			id: '24',
			label: 'Alternatives Citoyennes et Développement Durable',
		},
		ECONOMIE: { name: 'economie', id: '25', label: 'Économie Circulaire, Sociale et Solidaire' },
	},
	POSTE: {
		JOB: { id: '27' },
		BENEVOLE: { id: '28' },
	},
	ATELIER: {
		ACCESSOIRE: { name: 'accessoire', id: '31', label: 'Accessoire' },
		COUTURE: { name: 'couture', id: '33', label: 'Couture' },
		DECO: { name: 'deco', id: '30', label: 'Déco' },
		TAPISSERIE: { name: 'tapisserie', id: '32', label: 'Tapisserie' },
	},
	EVENTS: {
		ATELIER: { name: 'atelier', id: '4', label: 'Atelier' },
		EVENEMENT: { name: 'evenement', id: '6', label: 'Evenement' },
		VENTE: { name: 'vente', id: '5', label: 'Vente' },
	},
	COMMENTS: {
		ATELIER: { name: 'atelier', id: '38', label: 'Atelier' },
		ACCOMPAGNEMENT: { name: 'accompagnement', id: '39', label: 'Accompagnement' },
	},
}

export const EMAIL = {
	DOMICILE: 'Collecte à domicile',
	ARTISAN: 'Contacter les artisans',
	SENSIBILISATION: "Contacter l'équipe sensibilisation",
	BRICOTHEQUE: 'Contacter la bricothèque',
	POSTULER: 'Postuler',
	BENEVOLE: 'Devenir bénévole',
}
